import MovementsByTypeTable from './MovementsByTypeTable'

export default MovementsByTypeTable
